import { appModule } from './AppModule';
import { AppServices } from '@singularsystems/neo-core';
import { NeoReactModule } from '@singularsystems/neo-react';
import { AppService } from './Services/AppService';
import { ReportingModule } from '@singularsystems/neo-reporting';
import { AppReportingModule } from './AppReportingModule';
import { AuthorisationAppModule } from '../Authorisation/AuthorisationModule';
import { AccessControlAppModule } from '../AccessControl/AccessControlModule';
import { NotificationServiceModule } from '@singularsystems/neo-notifications';

const appService = AppService as AppServices.AppService;

appService.registerModule(AppServices.NeoModule);
appService.registerModule(NeoReactModule);
appService.registerModule(AuthorisationAppModule);
appService.registerModule(appModule);
appService.registerModule(AccessControlAppModule);
appService.registerModule(ReportingModule); // Neo Reporting Module
appService.registerModule(NotificationServiceModule);
appService.registerModule(AppReportingModule);